import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";

import { PlansAutocomplete, Form } from "@shared/components";

export interface MapIntegrationPlanFormProps {
  /** ID do convênio para filtrar planos no autocomplete */
  agreement?: number | string | null;
  /** Se deve permitir seleção múltipla de planos */
  multiplePlans?: boolean;
}

export function MapIntegrationPlanForm({ agreement, multiplePlans = false }: MapIntegrationPlanFormProps) {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <PlansAutocomplete
          multiple={multiplePlans}
          name={multiplePlans ? "plans" : "plan"}
          label={translate("subscription_mapintegrationplan_admin.fields.plan")}
          agreement={agreement}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="plan_slug_integration"
          label={translate("subscription_mapintegrationplan_admin.fields.plan_slug_integration")}
          instructions="Opcional se a lista abaixo estiver preenchida"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="plan_slug_integration_list"
          label={translate("subscription_mapintegrationplan_admin.fields.partner_plan_name_list")}
          instructions={translate("subscription_mapintegrationplan_admin.instructions.partner_plan_name_list")}
          multiline
          minRows={4}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input name="price_from" type="number" label="Preço de" inputProps={{ step: "0.01", min: 0 }} />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input name="price_to" type="number" label="Preço até" inputProps={{ step: "0.01", min: 0 }} />
      </Grid>
    </Grid>
  );
}
